import React from 'react';
import './confirmation.scss';
import { useNavigate } from "react-router-dom";
import { IProps } from './confirmationInterface';
import { MaskedTextBox, TextBox } from '@progress/kendo-react-inputs';
import { DataTable, TreeviewDropdown } from '../../CommonComponent';
import { RESOURCE } from "../../../const/resource";
import { useTranslation } from "react-i18next";
import Loader from '../../Loader';
import helperfunctions from '../../../utils/helperfunctions';
import { Error } from "@progress/kendo-react-labels";

const PriceView = (row: any) => {
    const { t } = useTranslation();
    return (<td>{helperfunctions.getUnitPrice(row?.dataItem?.price, t, row?.dataItem?.isContactDealer)}</td>);
}

const PromoPriceView = (row: any) => {
    return (<td>${helperfunctions.formatAmount(row?.dataItem?.promoPrice)}</td>);
}

const Confirmation = (props: IProps) => {

    const { t } = useTranslation();
    const { primaryContact, onAddForFuture, orderConfirmationDetails, printResponse, errMsg, onClickSend, orderSummaryData, isAddMore, inputValue, handleAddInput, handleAddMobile, handleChange, handleChangeMobile, handleChangePhoneCode, onAddMore, confirmationSummaryData } = props;
    const { shippingInfo, shippingMethod, payment, pickupInfo, specialInstructions, isPromoCodeApplied, fullFillmentSummary } = orderSummaryData?.data ?? {};
    const { shippingAddress, contact } = shippingInfo ?? {}
    const { order, shipment } = props?.stepperDetails ?? {};
    const { isShippingType, isPickupType } = shipment ?? {};
    const isDisabled = props?.sendNotificationRes?.data?.isSuccessful === true;
    const shippingMethodName = shippingMethod?.name?.toLowerCase();
    const isDeliveryOrDropbox = shippingMethodName == "delivery" || shippingMethodName == "dropbox" || shippingMethodName == "freight truck";
    const { pickupAddress } = pickupInfo ?? {};
    const splInstruction = specialInstructions ?? order?.splInstruction;

    const getColumns = () => {
        let columns = [
            {
                field: "partNumber",
                title: t(RESOURCE.MyK_Grid_Part_Number),
                sortable: false,
            },
            {
                field: "partDescription",
                title: t(RESOURCE.MyK_Grid_Part_Name),
                sortable: false
            },
            {
                field: "quantity",
                title: t(RESOURCE.MyK_Grid_Quantity),
                sortable: false
            },
            {
                field: "price",
                title: t(RESOURCE.MyK_Grid_Price),
                sortable: false,
                style: { textAlign: 'right' },
                cell: PriceView
            }
        ];
        if (isPromoCodeApplied) {
            columns.push({
                field: "promoPrice",
                title: t(RESOURCE.MyK_Label_ShoppingCart_Promo_Price),
                sortable: false,
                style: { textAlign: 'right' },
                cell: PromoPriceView
            });
        }

        return columns;
    }

    const columns = getColumns();

    const { total, mykReferenceNumber } = orderConfirmationDetails?.data ?? {};

    const navigate = useNavigate();
    const backtoHome = () => {
        navigate({
            pathname: "/myFleet",
        });
        window.scrollTo(0, 0);
    }

    const getMobileErrorMessage = (item: any) => {
        const { isValidMobile, isDuplicateMobile, isSentSms } = item;
        if (isValidMobile === false) {
            if (item?.mobile?.length == 0) {
                return t(RESOURCE.MyK_Label_ShoppingCart_Phone_Req)
            }
            if (item?.phoneCode?.length == 0) {
                return t(RESOURCE.MyK_Label_ShoppingCart_FC_PhoneCode_Req)
            }
            if (item?.phoneCode == "+1") {
                return t(RESOURCE.MyK_Label_ShoppingCart_Phone_Invalid);
            }
            return (t(RESOURCE.MyK_Label_ShoppingCart_Phone_Invalid));
        } else if (isSentSms === true) {
            return t(RESOURCE.MyK_Label_SC_Phone_Already_Sent);
        } else if (isDuplicateMobile === true) {
            return t(RESOURCE.MyK_Label_SC_Phone_Duplication);
        } else {
            return null;
        }
    };

    const getEmailErrorMessage = (item: any) => {
        const { isValidEmail, isDuplicateEmail, isSentMail } = item;
        if (isValidEmail === false) {
            return t(RESOURCE.MyK_Label_ShoppingCart_Email_Invalid);
        } else if (isSentMail === true) {
            return t(RESOURCE.MyK_Label_SC_Email_Already_Sent);
        } else if (isDuplicateEmail === true) {
            return t(RESOURCE.MyK_Label_SC_Email_Duplication);
        } else {
            return null;
        }
    };
    const isLoading = props?.addForFutureRes?.loading || orderConfirmationDetails?.loading || printResponse?.loading || confirmationSummaryData?.loading || orderSummaryData?.loading || props?.sendNotificationRes?.loading || props?.shareOrderConfirmationRes?.loading;

    const getValue = (value: any) => {
        return value ??"";
    }

    const isValidPhone = (phoneNumber: any) => {
        const index = phoneNumber?.indexOf(" ");
        if (phoneNumber?.trim()?.length >= 10 || (phoneNumber?.substring(index)?.trim()?.length > 0)) {
            return true;
        }
        return false;
    }

    const formatPhoneNumber = (phoneNumber:any) => {
        if (phoneNumber.startsWith('+1 ') && phoneNumber.length >= 13) {
            return phoneNumber.replace(/^\+1\s?(\d{3})(\d{3})(\d{4})$/, '+1 ($1) $2-$3');
        }
        return phoneNumber;
    }

    const checkContacDealerTotal = (fullfilmenttype: any, total: any) => {
        if (fullfilmenttype?.toLowerCase() == 'contactdealer' && total == 0) {
            return "N/A";
        }
        else {
            return `$${helperfunctions.formatAmount(total)}`
        }
    }

    return (
        <div className="confirmation_outer-wrapper">
            <div className="confirmation_wrapper">
                {(isLoading) && <span className="confirmationLoader"><Loader /></span>}
                <div className="confirmation_contents">
                    <div className="row mb-3 mt-5">
                        <div className="col-12">
                            <span className="Confirmation_inner-title">{t(RESOURCE.MyK_SC_Order_Confirmed)}</span>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-12">
                            <span className="Order_Number">{t(RESOURCE.MyK_SC_Order_Number)}: {mykReferenceNumber}</span>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-12">
                            <span className="Confirmation_inner-text">{t(RESOURCE.MyK_SC_Order_Confirmed_Text)}</span>
                        </div>
                    </div>
                </div>
                <div className="confirmation_inner-wrapper mb-3">
                    {
                        primaryContact?.length > 0 && primaryContact.map((data: any) => {
                            const isEmailType = data?.type?.toLowerCase() === 'email'; 
                            const isPhoneType = data?.type?.toLowerCase() === 'sms';
                            const isStatusVisible = (isEmailType || (isPhoneType && isValidPhone(data?.value)));
                            const value = isEmailType ? data?.value : formatPhoneNumber(data?.value);
                            return < div key={data?.value} className={`EmailView ${(isAddMore) ? 'borderLine' : ''}`}>
                                <div className='sentEmails'>
                                    <div className={`labelType ${isEmailType ? 'email' : 'sms'}`}>{isEmailType ? 'Email' : 'SMS'}:</div>
                                    <div className='emailContent'>{isStatusVisible ? value : 'N/A'}</div>
                                </div>
                                {isStatusVisible && <div className='sentView'>{data?.status}</div>}
                            </div >
                        })
                    }
                    {(!isAddMore) && <div className='addMoreText'>{t(RESOURCE.MyK_SC_Order_Add_More_Info1)} <span className='addMore' aria-hidden={true} onClick={onAddMore}>{t(RESOURCE.MyK_SC_Order_Add_More_Info2)}</span> {t(RESOURCE.MyK_SC_Order_Add_More_Info3)}</div>}
                </div>
                <div className="confirmation_inner">
                    {
                        isAddMore && <>
                            <div>
                                {inputValue.map((item: any, index: any) => (
                                    item?.hasOwnProperty('email') && <div className="emailInputView emaildata" key={item?.key}>
                                        <div className='emailField'>
                                            {index === 0 ? <label htmlFor="email" className='labelView'>{t(RESOURCE.MyK_Label_ShoppingCart_Email)}</label> : <label htmlFor="email" className='labelView'></label>}
                                            <input disabled={isDisabled} type="text" className="textbox Email" name="email" value={item?.email} onChange={(event: any) => handleChange(event, index)} />
                                            <Error className={`errMsg ${index === 0 ? 'initialField' : ''}`}>
                                                {getEmailErrorMessage(item)}
                                            </Error>
                                        </div>
                                        {(item?.isLastEmail && !isDisabled) ?
                                            <div aria-hidden={true} onClick={() => handleAddInput(index)} className={`addEmail ${!item?.email ? 'disabled' : ''}`}>
                                                <span className={`fa fa-plus-circle mr-2 circleView ${!item?.email ? 'disabled' : ''}`}></span>{t(RESOURCE.MyK_Label_ShoppingCart_Add_Email)}</div> :
                                            <div className='sentView'>{isDisabled ? t(RESOURCE.MyK_Label_Sent) : null}</div>}
                                    </div>))}
                            </div>
                            <div>
                                {inputValue.map((item: any, index: any) => (
                                    item?.hasOwnProperty('mobile') && <div className="emailInputView emaildata" key={item?.key}>
                                        <div className='mobileField'>
                                            {index === 0 ? <label htmlFor="mobile" className='labelView'>{t(RESOURCE.MyK_Label_ShoppingCart_SMS)}</label> : <label htmlFor="mobile" className='labelView'></label>}
                                            <div className="phonecode-ddl">
                                            <TreeviewDropdown
                                                onChange={(event: any) => handleChangePhoneCode(event, index, "phoneCode")}
                                                value={item?.phoneCode ?? ''}
                                                treeData={props?.phoneCodeOption}
                                                treeNodeFilterProp={"title"}
                                                dropdownClassName={'dropdownListContainer'}
                                                className={'phone'}
                                                disabled={isDisabled}
                                                showSearch={true}
                                                />
                                            </div>
                                            {item?.phoneCode == "+1" ? <MaskedTextBox disabled={isDisabled} className="textbox textViewMobile" mask="(999) 000-0000" defaultValue={item?.mobile} onChange={(event: any) => handleChangeMobile(event, index, "mobile")} />
                                             : <TextBox
                                                disabled={isDisabled}
                                                onChange={(event: any) => handleChangeMobile(event, index, "mobile")}
                                                defaultValue={item?.mobile}
                                                value={item?.mobile}
                                                className='textbox textViewMobile'
                                                maxLength={15}
                                            />}
                                            <Error className={`errMsg phone ${index === 0 ? 'initialField' : ''}`}>
                                                {getMobileErrorMessage(item)}
                                            </Error>
                                        </div>
                                        {(item?.isLastMobile && !isDisabled) ?
                                            <div aria-hidden={true} onClick={() => handleAddMobile(index)} className={`addEmail addPhone ${(!item?.mobile || !item?.phoneCode) ? 'disabled' : ''}`}>
                                                <span className={`fa fa-plus-circle mr-2 circleView ${(!item?.mobile || !item?.phoneCode) ? 'disabled' : ''}`}></span>{t(RESOURCE.MyK_Label_ShoppingCart_Add_Phone)}</div> :
                                            <div className='sentView'>{isDisabled ? t(RESOURCE.MyK_Label_Sent) : null}</div>}
                                    </div>))}
                            </div>
                            {errMsg?.isEmpty && <Error className='btnOptionView errReqMsg'>{String(t(RESOURCE.MyK_Label_SC_Order_Send_Req_Msg))}</Error>}
                            {!isDisabled && <><div className="btnOptionView">
                                <button className="sendbutton" onClick={onClickSend}>{t(RESOURCE.MyK_Label_Send)}</button>
                            </div>
                                <div className="btnOptionView">
                                    <span><input type="checkbox" className="mr-2 checkbox rememberfuture_check"
                                        onChange={(e) => {
                                            onAddForFuture(e?.target?.checked ?? false)
                                        }} /></span><span className="checkboxlabel">{t(RESOURCE.MyK_Label_SC_Add_Contacts_For_Future)}</span>
                                </div></>}
                        </>
                    }
                    <div className="btnOptionView Center mt-4">
                        <button className="secondarybutton secondarybutton_cofirmation mr-2 ml-2" onClick={backtoHome}>{t(RESOURCE.MyK_BreadcrumbHeader_Home)}</button>
                        <button className="secondarybutton secondarybutton_cofirmation mr-2" onClick={props?.onPrintOrderConfirmation}>{t(RESOURCE.MyK_Label_Print)}</button>
                    </div>
                </div>
                <div>
                </div>
                <div className="confirmation_contents">
                    <div className="esttotal mb-4">
                        <div className="row">
                            <div className="col-8">
                                <span className="totaltext">{t(RESOURCE.MyK_Label_SC_Order_Est_Total)}</span>
                                <div>
                                    <span className="totalsubtext">{t(RESOURCE.MyK_Label_SC_Order_Est_Total_With_Shipping)}</span>
                                </div>
                            </div>
                            <div className="col-4">
                                <span className="totalamount">${helperfunctions.formatAmount(total?.estTotal??0)}</span>
                                <span className="totalsubamount">${helperfunctions.formatAmount(total?.estPreTaxWithShipping??0)}</span>
                            </div>
                        </div>
                    </div>

                    <div className="orderconfirmation_contents">
                        <div className="custom_header mb-3">
                            <span>{t(RESOURCE.MyK_Label_SC_Order_Summary)}</span>
                        </div>
                        <div className="ordersummary_wrapper mb-4">
                            {fullFillmentSummary?.length > 0 && fullFillmentSummary?.map((summaryData: any) =>
                            (
                                <div key={summaryData?.title}>
                                    <div className="orderSummaryTypeTitle mb-2 mt-4">{summaryData?.title}</div>
                                    <DataTable
                                    storageKey={"confirmation"} enableFiltering={true}
                                        data={summaryData?.partDetails ?? []}
                                        dataColumn={columns}
                                        className={'orderSummaryTable'}
                                        pagination={false}
                                        defaultPageSize={summaryData?.partDetails?.length ?? 0}
                                    />
                                    <div className='p-2 summaryTotal_wrapper'>
                                        <div className='summaryTotal_content mb-2'>
                                            <p className='mr-2 lable'>{t(RESOURCE.MyK_Label_SC_Fullfilment_Total)} </p><p className='amount'>{checkContacDealerTotal(summaryData?.fulfillmentType, summaryData?.total?.estTotal ?? 0)}</p>
                                        </div>
                                        {summaryData?.total?.promoCodeWithPrice?.length > 0 &&
                                            <>
                                        <div className='summaryTotal_content mb-2'>
                                                <p className='mr-2 lable'>{t(RESOURCE.MyK_Label_ShoppingCart_Promo_Code_Discount)} </p><p className='amount'></p>
                                            </div>
                                            {summaryData?.total?.promoCodeWithPrice?.map((t: any) => (
                                                <div className='summaryTotal_content mb-2' key={t.promoCode}>
                                                    <p className='mr-2 lable'>{t.promoCode} </p><p className='amount'>{checkContacDealerTotal(summaryData?.fulfillmentType, t?.totalPrice ?? 0)}</p>
                                                </div>
                                            ))}
   
                                            <div className='summaryTotal_content mb-2'>
                                                <p className='mr-2 lable'>{t(RESOURCE.MyK_Label_SC_Fullfilment_Total_AfterDiscount)} </p><p className='amount'>{checkContacDealerTotal(summaryData?.fulfillmentType, summaryData?.total?.estTotalAfterDiscount ?? 0)}</p>
                                            </div>
                                        </>
                                        }

                                        {(summaryData?.showShippingCost && !isDeliveryOrDropbox) && <div className='summaryTotal_content mb-2'>
                                            <p className='mr-2 lable'>{t(RESOURCE.MyK_Label_SC_Est_Shipping_Total)}</p><p className='amount'>{checkContacDealerTotal(summaryData?.fulfillmentType, summaryData?.total?.estPreTaxWithShipping ?? 0)}</p>
                                        </div>}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="custom_header mb-4">
                            <span>{t(RESOURCE.MyK_Label_SC_Spl_Instruction)}</span>
                        </div>
                        <div className="ordercontent_wrapper mb-4">
                            <span className='splInstruction'>{splInstruction || ' - '}</span>
                        </div>
                        <div>
                            <div className='custom_header'>
                                <span>{t(RESOURCE.MyK_Label_SC_Order_Information)}</span>
                            </div>
                            <div className="ordercontent_wrapper mb-4">
                                {isPickupType && <div>
                                    <div className="orderInfoTitle mb-2 mt-4">{t(RESOURCE.MyK_Label_SC_Order_Pickup_Info)}</div>
                                    <div className="mb-2">{getValue(pickupAddress?.companyName)}</div>
                                    <div className="row">
                                        <div className="col-12 col-md-6 col-xl-10">
                                            <span>{getValue(pickupAddress?.address1)}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 col-md-6 col-xl-10">
                                            <span>{getValue(pickupAddress?.address2)}</span>
                                        </div>
                                    </div>
                                    <div className="mb-2">{`${getValue(pickupAddress?.city)}, ${getValue(pickupAddress?.state)}, ${getValue(pickupAddress?.zipCode)} ${getValue(pickupAddress?.countryName)}` }</div>
                                </div>}
                                {isShippingType && <div>
                                    <div className="orderInfoTitle mb-2 mt-4">{t(RESOURCE.MyK_Label_SC_Order_Shipping_Info)}</div>
                                    <div className="mb-2">{`${getValue(shippingAddress?.firstName)} ${getValue(shippingAddress?.lastName)}`}</div>
                                    <div className="row">
                                        <div className="col-12 col-md-6 col-xl-3">
                                            <span>{getValue(shippingAddress?.address1)}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 col-md-6 col-xl-3">
                                            <span>{shippingAddress?.address2 ?? ''}</span>
                                        </div>
                                    </div>
                                    <div className="mb-2">{`${getValue(shippingAddress?.city)}, ${getValue(shippingAddress?.state)}, ${getValue(shippingAddress?.zipCode)} ${getValue(shippingAddress?.countryName)}`}</div>
                                    <div className="mb-2">{shippingAddress?.phoneCountryCode} {shippingAddress?.phone} </div>
                                </div>}
                            </div>
                        </div>
                        {isPickupType &&
                            <>
                        <div className="custom_header mb-4">
                            <span>{t(RESOURCE.MyK_Label_SC_Contact)}</span>
                        </div>
                        <div className="ordercontent_wrapper mb-4">
                            <div className="mb-2">{contact?.phoneCountryCode} {contact?.phone}</div>
                            <div>{contact?.name}</div>
                            </div>
                        </>
                        }
                        {isShippingType && <>
                            <div className="custom_header mb-4">
                                <span>{t(RESOURCE.MyK_Label_SC_Shipping_Method)}</span>
                            </div>
                            <div className="ordercontent_wrapper mb-4">
                                <div className="mb-2">{shippingMethod?.name}</div>
                                <div>
                                    {!isDeliveryOrDropbox && <><span className="mr-3">{t(RESOURCE.MyK_Label_SC_Est_Shipping_Cost)}</span><span>${helperfunctions.formatAmount(shippingMethod?.estcost ? Number(shippingMethod?.estcost) : 0)}</span></>}
                                </div>
                            </div>
                        </>}

                        <div className="custom_header mb-4">
                            <span>{t(RESOURCE.MyK_Label_SC_Payment)}</span>
                        </div>
                        {(payment?.method && payment?.method.toLowerCase() === "kc") && <div className="ordercontent_wrapper mb-4">
                            <div className="mb-2">{payment?.creditcard?.cardType}</div>
                            <div  className="mb-1">
                                <span>{payment?.creditcard?.nameOnCard}</span>
                            </div>
                            <div  className="mb-1">
                                <span className="cardnumber">{payment?.creditcard?.cardNumber}</span>
                            </div>
                        </div>}
                        {(payment?.method && payment?.method.toLowerCase() === "ac") &&
                            <div className="ordercontent_wrapper mb-4">
                                <div className="mb-2">{t(RESOURCE.MyK_Label_SC_Open_Account)}</div>
                                <span className="cardnumber">{payment?.openAccount?.poNumber}</span>
                            </div>}
                        {(payment?.method && payment?.method.toLowerCase() === "co") &&
                            <div className="ordercontent_wrapper mb-4">
                                <div className="mb-2">{t(RESOURCE.MyK_Label_SC_Cash_On_Delivery)}</div>
                            </div>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Confirmation


